import React from 'react';
import { Controller } from 'react-hook-form';
import { Typography } from '@navi/web-ui/lib/primitives';
import ErrorIconOutline from '@cp/src/assets/icons/ErrorIconOutline';
import Dropdown from '@cp/src/components/Dropdown';
import { AgencyFormStatesDropdownProps } from '../../interfaces/types';

const AgencyFormStatesDropdown: React.FC<AgencyFormStatesDropdownProps> = props => {
  const { control, errors, name, isEditDisabled, styles, validationMessage, options, rules } =
    props;

  return (
    <>
      <div className={styles.textContainer}>
        <Typography variant="p4" color="var(--navi-color-gray-c2)">
          Serviceable States
        </Typography>
      </div>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, value } }) => (
          <Dropdown
            placeholder={'Enter here'}
            placeholderColor={'var(--navi-color-gray-c3)'}
            showSolidArrow={true}
            arrowIconWidth={9}
            options={options}
            onSelectionChange={onChange}
            multiSelect={true}
            selectedValue={value}
            containerClasses={styles.dropdownContainer}
            disabled={isEditDisabled}
            error={errors?.[name]?.message}
            showEllipsisTooltip={true}
            pickerContainerClasses={'max-h-[266px]'}
            showTextCursorOnDisabled={true}
            tabIndexEnabled={true}
          />
        )}
      />
      {errors?.[name] ? (
        <div className={styles.errorContainer}>
          <ErrorIconOutline />
          <Typography variant="p4" className={styles.errorText}>
            {validationMessage}
          </Typography>
        </div>
      ) : null}
    </>
  );
};

export default AgencyFormStatesDropdown;
